import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.less';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { store } from './app/store';
// import '@fontsource/source-sans-pro';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalInstance'; // <-- 👈 adjust if your path differs

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );

ReactDOM.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
